import {Component, Module} from 'app/decorators';
import _ from 'lodash';

import HiddenCustomersStore from 'app/stores/hiddenCustomers';
import BasePicker from './base.picker';
import tpl from './customer.picker.html';
import angular from "angular";


@Module({
    name: "app.directives.customer.picker",
    modules: [HiddenCustomersStore],
})
@Component({
    selector: 'blnd-customer-picker',
    bindings: {
        ngModel: '=',
        ngDisabled: '=',
        ngChange: '&',
        company: '<',  // one-way binding
        mode: '=',
        clearOnChange: '=?'
    },
    template: tpl,
})
export default class C extends BasePicker {

    constructor ($scope, HiddenCustomersStore, $element) {
        "ngInject";
        super($element);
        this.scope = $scope;
        this.store = HiddenCustomersStore;
        this.store.init();
        this.store.params.is_active = 'True';

        this.clearOnChange = this.clearOnChange || false
    }

    $onInit () {
        let self = this;
        if (!self.ngChange) {
            return;
        }

        this.watcher = this.scope.$watch(() => self.ngModel, function (newValue, oldValue) {
            if (newValue === oldValue) { return; }
            if (!self.ngChange) { return }

            self.ngChange();
        }, true);
    }

    $onChanges (changesObj) {
        if (!this.company) { return ; }
        let currentCompanyId = this.getCompanyId(changesObj.company.currentValue);

        if (!_.isUndefined(currentCompanyId)) {
            this.store.params.companies = currentCompanyId;

            if (this.clearOnChange && !(changesObj.company.isFirstChange && changesObj.company.isFirstChange())) {
                // Do not reset value on first change
                this.ngModel = '';
                this.store.refresh();
            }

        }
    }

    getCompanyId (obj) {
        if (_.isObject(obj) && obj.id) {
            return obj.id;
        }

        return _.isNumber(obj) ? obj : undefined;
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/customer.picker.js